import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { HelpCircle, CheckCircle2 } from 'lucide-react';

/**
 * Newsletter Section - Integrated with Substack
 * URL: https://corentinleroux.substack.com
 */
export function NewsletterSection() {
  const { t, i18n } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale || i18n.language || 'fr';
  const substackUrl = 'https://corentinleroux.substack.com';
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const email = formData.get('email') as string;

    // Envoyer à Substack en arrière-plan (no-cors car domaine différent)
    fetch(`${substackUrl}/api/v1/free`, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({ email }),
    });

    setSubscribed(true);
  };

  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="max-w-3xl mx-auto">
          {/* Red Card Container */}
          <div className="bg-[#F06C6E] rounded-2xl p-6 md:p-8 shadow-xl">
            <div className="text-center">
              <div className="flex items-center justify-center gap-3 mb-4">
                <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-white">
                  {t('newsletter.title')}
                </h2>
                <Link
                  to={`/${currentLocale}/about-newsletter`}
                  className="text-white/80 hover:text-white transition-colors"
                  title={t('newsletter.learnMore')}
                >
                  <HelpCircle className="w-6 h-6 md:w-7 md:h-7" />
                </Link>
              </div>

              {subscribed ? (
                <div className="py-4">
                  <CheckCircle2 className="w-12 h-12 text-white mx-auto mb-4" />
                  <p className="text-xl font-bold text-white mb-2">
                    {t('newsletter.success')}
                  </p>
                  <p className="text-white/80 text-sm">
                    {t('newsletter.poweredBy')}
                  </p>
                </div>
              ) : (
                <>
                  <p className="text-lg text-white/90 mb-8">
                    {t('newsletter.description')}
                  </p>

                  <form
                    onSubmit={handleSubmit}
                    className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto"
                  >
                    <input
                      type="email"
                      name="email"
                      placeholder={t('newsletter.emailPlaceholder')}
                      required
                      className="flex-1 px-4 py-3 rounded-lg border-2 border-white/20 bg-white/10 text-white placeholder:text-white/60 focus:outline-none focus:ring-2 focus:ring-white focus:border-white focus:bg-white/20"
                    />
                    <button
                      type="submit"
                      className="px-8 py-3 bg-white text-aspexit-black font-semibold rounded-lg hover:bg-gray-100 transition-colors shadow-md"
                    >
                      {t('newsletter.subscribe')}
                    </button>
                  </form>

                  <p className="mt-6 text-sm text-white/80">
                    {t('newsletter.poweredBy')}
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

    </section>
  );
}
